import Icon from 'veui/components/Icon'
import { IconChat } from 'dls-icons-vue'

Icon.register('chat', IconChat)
